// Pulls a human-readable message out of a JSON:API-style error response
// (`{ errors: [{ title, detail }, ...] }`) with a fallback to a top-level
// `message` string. Used by services and components that surface server
// validation failures in toasts/inline errors.
export const extractServerErrorMessage = (result: {
  errors?: unknown
  message?: string
}): string | undefined => {
  const first = Array.isArray(result.errors) ? result.errors[0] : undefined
  if (first && typeof first === 'object') {
    const title =
      typeof (first as { title?: unknown }).title === 'string'
        ? (first as { title: string }).title.trim()
        : undefined
    const detail =
      typeof (first as { detail?: unknown }).detail === 'string'
        ? (first as { detail: string }).detail.trim()
        : undefined
    if (title && detail)
      return `${title.charAt(0).toUpperCase()}${title.slice(1)} ${detail}`
    if (detail) return detail
    if (title) return title
  }
  return result.message
}
